module.exports = __webpack_public_path__ + "static/media/gateway-online.42bf373e.svg";